export const CONFIG = {
    API_BASE_URL:
        'https://host.geeteksilver.abnb.vn',
    ADMIN_BASE_URL:
        'https://admin.geeteksilver.abnb.vn',
    ADMIN_BASE_URL_LOGIN:
        'https://admin.geeteksilver.abnb.vn/#/login',
    ADMIN_BASE_URL_REGISTER:
        'https://admin.geeteksilver.abnb.vn/#/register'
};